import Image from 'next/future/image';
import UsedPhoneIcon from '@/public/images/buyback/reebelo-sell-phone.png';
import DoorstepPaymentIcon from '@/public/images/buyback/reebelo-doorstep-payment.png';
import SafePaymentIcon from '@/public/images/buyback/reebelo-safe-payment.png';
import settings from '@/settings';

export default function StepsFeatured(props: { customText: string }) {
  const { customText } = props;
  const stepsData =
    settings.store === 'reebelo-us'
      ? [
          {
            img: UsedPhoneIcon,
            title: `BEST PRICES`,
            description: `Tell us about your ${customText}. We'll find the highest buyback price in the market for you!`,
            alt: 'quote-used-phone',
          },
          {
            img: DoorstepPaymentIcon,
            title: `FREE SHIPPING`,
            description: `Free & secure shipping. We'll conveniently send you a UPS prepaid label.`,
            alt: 'free-pickup',
          },
          {
            img: SafePaymentIcon,
            title: `FAST PAYMENT`,
            description: `Your device is inspected within 1-2 business days upon receiving & payment initiated within 48 hours after device condition validation.`,
            alt: 'payment',
          },
        ]
      : [
          {
            img: UsedPhoneIcon,
            title: `BEST PRICES`,
            description: `Tell us about your ${customText}. We'll find the highest buyback price in the market for you!`,
            alt: 'quote-used-phone',
          },
          {
            img: DoorstepPaymentIcon,
            title: `FREE SHIPPING`,
            description: `Free & secure shipping. We'll conveniently send you an ${settings.country} Post mailbag or prepaid label.`,
            alt: 'free-pickup',
          },
          {
            img: SafePaymentIcon,
            title: `FAST PAYMENT`,
            description: `Your device is inspected within 1-2 business days & payment initiated within 24 hours.`,
            alt: 'payment',
          },
        ];

  return (
    <div className="flex flex-wrap">
      {(stepsData || []).map((item, index) => (
        <div
          className="flex items-center p-4 px-2 pb-0 sm:w-1/3 sm:flex-col sm:px-4 sm:pb-4 sm:text-center"
          key={index}
        >
          <div className="mb-2 inline-flex h-20 w-12 shrink-0 items-center justify-center rounded-full sm:w-20">
            <Image
              className="rounded object-cover object-center"
              alt={item.alt}
              src={item.img}
              height={80}
              width={80}
            />
          </div>
          <div className="grow pl-4 sm:pl-0">
            <h2 className="mb-0 flex items-center text-[15px] font-bold uppercase text-blue-500 sm:mb-3 sm:justify-center md:text-lg">
              <p className="mr-3 hidden h-6 w-6 items-center justify-center rounded-full bg-blue-500 pt-0.5 text-sm font-bold text-white sm:flex">
                {index + 1}
              </p>{' '}
              {item?.title}
            </h2>
            <p className="text-sm leading-4 text-gray-700 sm:leading-[22px]">
              {item?.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
